import React, {Component, PropTypes} from 'react'
import {connect} from 'react-redux'
import {push} from 'react-router-redux'
import {Pagination} from 'react-bootstrap'
import {connectLoadingLock} from '../../core/redux/loading'
import {matchMedia} from '../../core/browser'
import {loadTicketStream} from '../actions'
import TicketCard from './TicketCard'
import style from './TicketStream.less'

const PAGE_SIZE = 20

class TicketStream extends Component {
    static propTypes = {
    	stream: PropTypes.array.isRequired,
        range: PropTypes.object.isRequired
    }

    _paginate(selectedEvent) {
        const {dispatch} = this.props

        const pageActive = selectedEvent.eventKey
        const offset = (pageActive - 1) * PAGE_SIZE
        const limit = offset + PAGE_SIZE - 1

        dispatch(loadTicketStream({range: {offset, limit}}))
    }

    _navigate(event, ticket) {
        const {dispatch} = this.props

        event.preventDefault()

        if (event.ctrlKey || event.metaKey) {
            window.open('/tickets/' + ticket.uid, '_blank')
        } else {
            dispatch(push('/tickets/' + ticket.uid))
        }
    }

    render() {
    	const {stream, range} = this.props

        const pageCount = Math.ceil(range.count / PAGE_SIZE)
        const pageActive = Math.floor(range.offset / PAGE_SIZE) + 1

        return (
        	<div>
        		{stream.map((ticket) => (
                    <TicketCard
                        key={ticket.uid}
                        ticket={ticket}
                        onClick={(e) => this._navigate(e, ticket)} />
                ))}
                <div className={style.pagination}>
                    <Pagination
                        items={pageCount}
                        maxButtons={matchMedia('sm') && 5 || 4}
                        activePage={pageActive}
                        onSelect={(e, se) => this._paginate(se)}
                        prev next first last ellipsis />
                </div>
        	</div>
        )
    }
}

TicketStream = connectLoadingLock()(TicketStream)

TicketStream = connect((state) => ({
    loading: state.loading,
    stream: state.ticket.stream,
    range: state.ticket.range
}))(TicketStream)

export default TicketStream


// WEBPACK FOOTER //
// ./lib/ticket/components/TicketStream.js